import { Box, Typography } from '@mui/material';

interface TimelineHeaderProps {
  startHour: number;
  endHour: number;
}

const formatHourLabel = (hour: number): string => {
  if (hour === 0 || hour === 24) return '12 AM';
  if (hour === 12) return '12 PM';
  if (hour < 12) return `${hour} AM`;
  return `${hour - 12} PM`;
};

const TimelineHeader: React.FC<TimelineHeaderProps> = ({ startHour, endHour }) => {
  const totalHours = endHour - startHour;
  const hours: number[] = [];
  for (let h = startHour; h <= endHour; h++) {
    hours.push(h);
  }

  return (
    <Box
      sx={{
        display: 'flex',
        pl: '52px', // Align with track (matches day label width)
        position: 'relative',
        height: 20,
        mb: 0.5,
      }}
    >
      <Box sx={{ flex: 1, position: 'relative' }}>
        {hours.map((hour) => {
          const percent = ((hour - startHour) / totalHours) * 100;
          return (
            <Typography
              key={hour}
              variant="caption"
              sx={{
                position: 'absolute',
                left: `${percent}%`,
                transform: 'translateX(-50%)',
                color: 'grey.500',
                fontSize: 10,
                fontWeight: 500,
                letterSpacing: 0.3,
                userSelect: 'none',
                whiteSpace: 'nowrap',
              }}
            >
              {formatHourLabel(hour)}
            </Typography>
          );
        })}
      </Box>
    </Box>
  );
};

export default TimelineHeader;
